import {
  ProCurrency,
  ProDetailList,
  ProText,
  ProTextArea,
} from '@bedrock/eed-react';
import {
  FormCard,
  FormItemBaseEnum,
  FormItemBaseFile,
  FormModule,
  SupplierDetailList,
  DigitalingOverall,
  DigitalingOverallRankingTable,
} from '@purchase/supplier';
import React, { FC, useState } from 'react';
import { ProxyListTable } from './ProxyListTable';
import { XpcSection } from './XpcSection';
import { ProCustomFieldDate } from '../../components/ProCustomFieldDate';
import { ProTextEllipsis } from '../../components/ProTextEllipsis';
import { ProCustomFieldDateRange } from '../../components/ProCustomFieldDateRange';
import { ProTextPercentage } from '../../components/ProTextPercentage';
import { Radio } from '@bedrock/components';

const options = [
  { name: '供应商录入', value: 1 },
  { name: '数英', value: 2 },
  { name: '新片场', value: 3 },
];

export const IndustryExperience: FC<{
  isExternal?: boolean;
  formDetail?: any;
  mode?: 'card' | 'module';
  namePath?: string[];
  vendorId: string;
}> = (props) => {
  const {
    isExternal = false,
    namePath = [],
    mode = 'card',
    formDetail,
    vendorId,
  } = props;
  const Wrapper = mode === 'card' ? FormCard : FormModule;
  const [value, setValue] = useState(1);

  const successCaseCount =
    formDetail?.extendAttributeInfo?.successCase?.length ?? 0;
  const industryAwardsCount =
    formDetail?.extendAttributeInfo?.industryAwards?.length ?? 0;
  const topCustomerCount =
    formDetail?.extendAttributeInfo?.topCustomer?.length ?? 0;

  return (
    <Wrapper title="行业经验">
      <FormModule
        title="成功案例"
        titleCount={successCaseCount}
        proCardProps={{
          expandable: true,
          defaultExpanded: successCaseCount > 0,
        }}
      >
        <SupplierDetailList
          name={['extendAttributeInfo', 'successCase']}
          fieldProps={{ scroll: { x: 1120 }, className: 'mb-[8px]' }}
        >
          <ProDetailList.Item
            label="#"
            name="#"
            meta={{ columnProps: { width: 50, fixed: true } }}
          >
            {(_, record) => {
              return {
                children: record?.$index + 1,
                props: {
                  rowSpan: record?.$rowSpan || 0,
                },
              };
            }}
          </ProDetailList.Item>
          <ProDetailList.Item
            label="行业类型"
            name={['industryType']}
            meta={{
              columnProps: { width: 200, className: 'font-bold', fixed: true },
            }}
          >
            {(_, record) => {
              return {
                children: <FormItemBaseEnum name={['industryType']} />,
                props: {
                  rowSpan: record?.$rowSpan || 0,
                },
              };
            }}
          </ProDetailList.Item>
          <ProDetailList.Item label="成功案例" name="successCaseContent">
            <ProTextArea />
          </ProDetailList.Item>
          <ProDetailList.Item
            label="附件"
            name="successCaseAttachment"
            meta={{ columnProps: { width: 240 } }}
          >
            <FormItemBaseFile />
          </ProDetailList.Item>
        </SupplierDetailList>
      </FormModule>
      <FormModule
        title="行业奖项"
        titleCount={industryAwardsCount}
        proCardProps={{
          expandable: true,
          defaultExpanded: industryAwardsCount > 0,
        }}
      >
        {!isExternal && (
          <Radio.Group
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className="mb-[12px]"
          >
            {options.map((option) => {
              return (
                <Radio.Button
                  checked={option.value === value}
                  disabled={option.disabled}
                  key={option.value}
                  value={option.value}
                >
                  <div className="inline-flex items-center gap-1">
                    <span>{option.name}</span>
                  </div>
                </Radio.Button>
              );
            })}
          </Radio.Group>
        )}
        {value === 2 && !isExternal && (
          <>
            <DigitalingOverall vendorId={vendorId} />
            <DigitalingOverallRankingTable
              vendorId={vendorId}
              className="mt-[12px]"
            />
          </>
        )}
        {value === 3 && !isExternal && (
          <XpcSection vendorId={vendorId} />
        )}

        <SupplierDetailList
          style={{ display: value === 1 || isExternal ? 'block' : 'none' }}
          name={['extendAttributeInfo', 'industryAwards']}
          fieldProps={{ scroll: { x: 1120 } }}
        >
          <ProDetailList.Item
            label="#"
            name="#"
            meta={{ columnProps: { width: 50, fixed: true } }}
          >
            {(value, record, index) => {
              return index + 1;
            }}
          </ProDetailList.Item>
          <ProDetailList.Item
            label="奖项名称"
            name="awardName"
            meta={{
              columnProps: { width: 200, className: 'font-bold', fixed: true },
            }}
          >
            <ProText />
          </ProDetailList.Item>
          <ProDetailList.Item label="获奖项目" name="awardProject">
            <ProText />
          </ProDetailList.Item>
          <ProDetailList.Item
            label="获奖时间"
            name="awardedAt"
            meta={{ columnProps: { width: 240 } }}
          >
            <ProCustomFieldDate />
          </ProDetailList.Item>
          <ProDetailList.Item
            label="获奖案例"
            name="winningCases"
            meta={{ columnProps: { width: 240 } }}
          >
            <FormItemBaseFile />
          </ProDetailList.Item>
        </SupplierDetailList>
      </FormModule>
      <FormModule
        title="头部客户"
        titleCount={topCustomerCount}
        proCardProps={{
          expandable: true,
          defaultExpanded: topCustomerCount > 0,
        }}
      >
        <SupplierDetailList
          name={['extendAttributeInfo', 'topCustomer']}
          formItemProps={{
            className: 'mb-[0px]',
          }}
          fieldProps={{ scroll: { x: 1120 } }}
        >
          <ProDetailList.Item
            label="#"
            name="#"
            meta={{ columnProps: { width: 50, fixed: true } }}
          >
            {(value, record, index) => {
              return index + 1;
            }}
          </ProDetailList.Item>
          <ProDetailList.Item
            label="主要客户名称"
            name="customerName"
            meta={{
              columnProps: { width: 200, className: 'font-bold', fixed: true },
            }}
          >
            <ProText />
          </ProDetailList.Item>
          <ProDetailList.Item label="服务类型及内容" name="serviceTypeContent">
            <ProText />
          </ProDetailList.Item>
          <ProDetailList.Item
            label="合作期间"
            name="coopPeriod"
            meta={{ columnProps: { width: 200 } }}
          >
            <ProCustomFieldDateRange />
          </ProDetailList.Item>
          <ProDetailList.Item
            label="近两年收入金额（万）"
            name={['incomeAmountForTwoYears']}
            meta={{ columnProps: { width: 180 } }}
          >
            <ProCurrency
              valueFormat={{
                valueToField: (value: any, fieldProps: any) => {
                  if (value && value?.currency?.value) {
                    return { ...value, currency: value?.currency?.value };
                  }
                  return value;
                },
              }}
            />
          </ProDetailList.Item>
          <ProDetailList.Item
            label="近两年收入占比"
            name={['incomeProportionForTwoYears']}
            meta={{ columnProps: { width: 180 } }}
          >
            <ProTextPercentage />
          </ProDetailList.Item>
        </SupplierDetailList>
      </FormModule>
      {/* 代理清单 - 仅内包端展示 */}
      {!isExternal && <ProxyListTable vendorId={vendorId} />}
    </Wrapper>
  );
};
